<template>
	<v-container>
		<v-row>
			<v-col>
				<v-data-table
						:headers="headers"
						:items="items"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						class="safety-calendar actionTable"
						:search="search"
						hide-default-footer
						hide-default-header
						hide-default-body
						disable-pagination
				>
					<template v-slot:header="{ props: { headers } }">
						<thead class="v-data-table-header">
						<tr>
							<th
									:class="[{'orange--text':sortBy === item.value}, {'filter-active': filterClasses[item.value]}]"
									v-for="(item, index) in headers"
									:key="index"
									class="text-start sortable position-relative"
									:id="'container-'+item.value"
							>
								<v-menu
										:attach="'#container-'+item.value"
										:nudge-width="330"
										:max-width="330"
										:min-width="330"
										nudge-bottom="30"
										:close-on-content-click="false"
										transition="slide-x-transition"
										bottom
										right
										v-if="item.func"
										:content-class="'table-dd'"
								>
									<template v-slot:activator="{ on: menu, attrs }">
										<v-tooltip top color="teal">
											<template v-slot:activator="{ on: tooltip }">
                                                <span v-bind="attrs"
                                                      v-on="{ ...tooltip, ...menu }">{{ item.text }}</span>
											</template>
											<span>Filter</span>
										</v-tooltip>
									</template>
									<v-list>
										<v-list-item>
											<filter-table
													@change-sort="changeSort"
													@create-refresh="createRefresh"
													@filter-created="filterCreated"
													:data-filter="filtersList[item.value]"
													:model-filter="item.value"
													:filter-update="filterUpdate"
											/>
										</v-list-item>
									</v-list>
								</v-menu>
								<span v-else>{{ item.text }}</span>
								<v-tooltip
										v-if="item.value !== 'driving_hours' && item.value !== 'safety_status'"
										color="orange"
										top
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
												v-bind="attrs"
												v-on="on"
												@click="toggleOrder(item.value)"
												icon
												x-small
												class="ml-4"
										>
											<v-icon
													:class="{'orange--text':sortBy === item.value}"
													class="sort-icon"
													size="14"
											>compare_arrows
											</v-icon>
										</v-btn>
									</template>
									<span>Sort</span>
								</v-tooltip>
							</th>
							<th width="20"></th>
						</tr>
						</thead>
					</template>
					<template v-slot:body="{ items }">
						<tbody>
						<template v-for="(item, index) in items">
							<action-tr
									:key="index"
									:dataVal="item"
									:filterClasses="filterClasses"
									@updateEditActions="onEditActions"
									@deleteHandler="onDeleteHandler"
									:permissions="permissions"
							></action-tr>
						</template>
						</tbody>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import FilterTable from "../filter-table/filter-table.component";
import ActionTr from "./components/ActionTr";

export default {
	name: 'ActionsTable',
	components: {
		FilterTable,
		ActionTr
	},
	props: {
		listItems: Array,
		permissions: Object
	},
	computed: {
		headers() {
			return [
				{ text: "Time", value: "date", func: false, filterable: false, sortable: true },
				{ text: "Employee", value: "user", func: false, filterable: false, sortable: true },
				{ text: "Actions", value: "text", func: false, filterable: false, sortable: true },
			];
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
	},
	data() {
		return {
			employeeValue: '',
			valid: true,
			loading: false,
			checkItemPay: null,
			checkItemSend: null,
			filterUpdate: false,
			sortBy: "",
			sortDesc: false,
			up: [],
			search: "",
			link: null,
			menu: false,
			preload: true,
			filtersMarker: {},
			filters: {
				date: [],
				employee: [],
				notes: []
			},
			filtersList: {
				date: [],
				employee: [],
				notes: []
			},
			list: this.listItems,
			itemRemove: null,
			checkClasses: {},
		};
	},
	created() {
		for (let i = 0; i < this.headers.length; i++) {
			this.filtersMarker[this.headers[i].value] = true;
			this.checkClasses[this.headers[i].value] = false;
			this.filters[this.headers[i].value] = [];
			this.filtersList[this.headers[i].value] = [];
		}
	},
	watch: {
		preload(val) {
			this.$store.dispatch("actionPreloader", val);
		},
		listItems(val) {
			this.items = val;
			if (this.items.length) {
				this.setListsFilter(this.items);
			}
			if (val.length > 0) {
				this.preload = false;
			} else {
				this.preload = false;
			}
		}
	},
	methods: {
		onActions(values) {
			this.$emit('updateActions', values);
		},
		refreshFilters() {
			this.search = "";
			this.sortDesc = false;
			this.sortBy = "";
			this.items = this.listItems;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}

				this.filterUpdate = true;
			}
			this.setListsFilter(this.items);
		},

		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},

		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		setListsFilter(arr, col) {
			if (!col) {
				for (const i in this.filtersList) {
					this.filtersList[i] = [];
				}

				arr.forEach(item => {
					if (item.date) this.filtersList.date.push(item.date);
					if (item.employee) this.filtersList.employee.push(item.employee);
					if (item.notes) this.filtersList.notes.push(item.notes);
				});
			}
		},
		changeSort(val) {
			this.filters[val.key] = val.value;
			let arr = this.listItems;

			for (const item in this.filters) {
				if (this.filters[item].length) {
					arr = arr.filter((elem) => {
						if (item === "date") {
							if (this.filters[item].length === 2) {
								const firstDate = new Date(this.filters[item][0]).valueOf() - ((24 * 60 * 60 * 1000) - 1000);
								const lastDate = new Date(this.filters[item][1]).valueOf();
								const currentDate = new Date(elem[item]).valueOf();

								return currentDate >= firstDate && currentDate <= lastDate;
							}
						} else {
							const result = [];
							for (let i = 0; i < this.filters[item].length; i++) {
								if (elem[item] === this.filters[item][i]) {
									result.push(true);
								}
							}

							return result.length;
						}
					});
				}
			}
			this.filterClasses = this.filters;
			this.items = arr;
			if (
				val.key !== "to" ||
					val.key !== "from"
			) {
				this.setListsFilter(this.items, val.key);
			}
		},
		toggleOrder(val) {
			this.sortBy = val;
			this.sortDesc = !this.sortDesc;
		},
		onEditActions(values) {
			this.$emit('updateEditActions', values);
		},
		onDeleteHandler(value) {
			this.$emit('onDeleteAction', value);
		}
	}
};
</script>
<style lang="scss">
.sort-icon {
	transform: rotate(90deg);
}

.comment {
	min-width: 100px;
}

.safety-calendar.actionTable {
	.v-data-table__wrapper {
		overflow: auto !important;
		max-height: 604px;
		min-height: 400px;

		td, th {
			white-space: nowrap;
		}
	}
}

.actionTable {
	.v-data-table__wrapper {
		overflow-y: initial !important;
		overflow-x: initial !important;
	}

	&.v-data-table td {
		font-size: 12px !important;
		height: 36px !important;
	}

	.eld {
		a {
			display: inline-block;
			margin-right: 10px;
		}

		button {
			margin-right: 2px;
		}
	}
}

</style>
